var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.719094 5.33948L4.57851 6.95532V11.514C4.57851 11.9978 4.96337 12.39 5.43806 12.39C5.91274 12.39 6.29761 11.9978 6.29761 11.514V7.67507L11.1405 9.70263V23.8171L0.719094 19.4539V5.33948Z",
    fill: "#C2C7CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.16842L7.5267 6.29558L17.194 1.99764L21.9664 3.99575L12 8.16842Z",
    fill: "#C2C7CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 -0.176983L14.9797 1.07055L5.31246 5.3685L2.03356 3.99569L12 -0.176983Z",
    fill: "#C2C7CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8595 9.70263L23.2809 5.33948V19.4539L12.8595 23.8171V9.70263Z",
    fill: "#C2C7CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

export default __webpack_public_path__ + "static/media/box.528f3bdd.svg";
export { SvgComponent as ReactComponent };